import type { IAtom } from 'mobx';
import { createAtom } from 'mobx';

export class Sound {
  protected audio: HTMLAudioElement;

  playingAtom: IAtom;

  constructor(url: string) {
    this.audio = new Audio();
    this.audio.preload = 'auto';
    this.audio.src = url;

    this.playingAtom = createAtom('SoundStore.playing');

    this.audio.addEventListener('play', () => this.playingAtom.reportChanged());
    this.audio.addEventListener('pause', () => this.playingAtom.reportChanged());
  }

  stop(): void {
    this.audio.pause();
    this.audio.currentTime = 0;
  }

  play(): Promise<void> {
    return this.audio.play();
  }

  pause(): void {
    this.audio.pause();
  }

  get playing() {
    this.playingAtom.reportObserved();
    return !this.audio.paused;
  }
}
